import React, { useState, useRef } from 'react';
import useEventListener from '@use-it/event-listener';
import { range } from 'lodash-es';
import { pdfjs } from 'react-pdf';
import { copyFor } from 'config';
import { LoadingPage } from 'components/loading';
import {
  ScrollButton,
  StyledDocument,
  StyledPage,
  Wrapper,
} from './scrollable-terms.style';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const getCopy = copyFor('modules.notification.vnmTerms');

interface Props {
  checkTerms: () => void;
  contractVersion: {
    fileUrl: string;
  };
  onScrollToBottom: () => void;
}

export const ScrollableTerms = ({
  checkTerms,
  contractVersion,
  onScrollToBottom,
}: Props) => {
  const [numPages, setNumPages] = useState(0);
  const [width, setWidth] = useState(0);
  const ref = useRef<any>();

  const onLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const updateWidth = () => {
    const { clientWidth } = ref?.current || {};
    setWidth(clientWidth);
  };

  const scrollToBottom = () => {
    const { current } = ref || {};
    current.scrollTop = current.scrollHeight - current.clientHeight;
    onScrollToBottom();
    checkTerms();
  };

  const handleScroll = e => {
    const { offsetHeight, scrollHeight, scrollTop } = e.target;
    if (offsetHeight + scrollTop >= scrollHeight) {
      onScrollToBottom();
    }
  };

  useEventListener('resize', updateWidth, window);

  return (
    <Wrapper data-testid="scrollable-terms" ref={ref} onScroll={handleScroll}>
      <ScrollButton onClick={scrollToBottom}>
        {getCopy('buttons.scroll')}
      </ScrollButton>
      <StyledDocument
        file={contractVersion.fileUrl}
        onLoadSuccess={onLoadSuccess}
        loading={<LoadingPage />}
      >
        {range(numPages).map(num => (
          <StyledPage
            key={num}
            pageNumber={num + 1}
            loading={<LoadingPage />}
            width={width}
            onLoadSuccess={updateWidth}
          />
        ))}
      </StyledDocument>
    </Wrapper>
  );
};
